import {Component} from 'react';
import h from 'react-hyperscript';
import './SurveyStatus.scss';
import {h4, p} from 'Components/Typography/Typography';
import Button from 'Components/Buttons/Buttons';
import ShareLink from 'Components/ShareLink/ShareLink';
import BasicCard from 'Components/Cards/BasicCard';
import {SURVEY} from 'Src/utils/gtm/const';
import {pushEvent as pushGTMEvent} from 'Src/utils/gtm';
import {replaceCloseDatePlaceholder} from 'Src/utils/utils';

class SurveyAvailableState extends Component {
  sanitize(string) {
    const date = new Date(this.props.userStatus.dates.survey_close_date
        .replace('-', '/'));
    return replaceCloseDatePlaceholder(string, date);
  }

  createCtas() {
    const onSurveyClick = (e) => {
      pushGTMEvent(SURVEY.TAG, {
        event: SURVEY.EVENT,
        action: {survey_action: SURVEY.ACTION.START},
      });
    };
    const ctas = this.props.ctas.map((cta, i) => {
      if (cta.type === 'share-link-survey') {
        if (this.props.userStatus.admin_level !== 'Admin') {
          return null;
        }
        const slug = cta.title.replace(' ', '-').toLowerCase();
        const shareDisabled = !this.props.userStatus.survey_open_period_flag;
        return h(
            ShareLink,
            {
              id: `share-link-button--${i}`,
              slug: slug,
              shareUrl: this.props.shareUrl,
              disabled: shareDisabled,
              buttonClasses:
                `${shareDisabled ?
                  'button--inline--disabled' : ''}`,
            },
            null
        );
      } else if (cta.type === 'survey') {
        return h(
            Button,
            {
              key: `survey-status-cta--${i}`,
              type: 'basic',
              to: `/app/survey/${this.props.shareUrl.split('/').pop()}`,
              className: 'survey-message-cta',
              onClick: onSurveyClick,
              icon: '/assets/icons/survey-inverted.svg',
            },
            cta.title
        );
      } else {
        return h(
            Button,
            {
              key: `survey-status-cta--${i}`,
              type: cta.type,
              to: cta.href,
              className: 'survey-message-cta',
              onClick: onSurveyClick,
            },
            cta.title
        );
      }
    });
    return ctas;
  }

  render() {
    return h(
        BasicCard,
        {
          type: 'basic',
          className: 'report-overview__status status--no-report flex',
          id: 'report-single--transformation-survey',
        },
        h(
            'div',
            {
              className: 'flex--space-between flex--wrap',
            },
            h(
                'div',
                {
                  className: 'survey-status__container col-ratio-3',
                },
                [
                  h(
                      h4,
                      {
                        id: 'survey-status__title',
                        key: `survey-status__title`,
                        className: 'survey-status__title',
                      },
                      `${this.props.title}`
                  ),
                  h(
                      p,
                      {
                        key: `survey-status-share`,
                        className: 'text--grey survey-status__subtitle',
                        dangerouslySetInnerHTML:
                          this.sanitize(this.props.subtitle),
                      },
                      null
                  ),
                  h(
                      'div',
                      {
                        key: 'survey-status-ctas',
                        className: 'flex flex--wrap',
                      },
                      this.createCtas()
                  ),
                ]
            ),
        )
    );
  }
}

export default SurveyAvailableState;
